import BaseModel from 'src/model/base.model';

export interface IStatementData {
  amount: number;
  current: number;
  customerPO: string;
  dueDate: string;
  firstMonthPastDueAmount: number;
  invoiceDate: string;
  invoiceNumber: number;
  secondMonthPastDueAmount: number;
  thirdMonthPastDueAmount: number;
}

class MonthlyStatementModel extends BaseModel {
  public addressLineFour: string;
  public addressLineOne: string;
  public addressLineThree: string;
  public addressLineTwo: string;
  public adjustments: number = 0;
  public beginningBalance: number = 0;
  public chargesOrCredits: number = 0;
  public customerName: string;
  public customerNumber: string;
  public endingBalance: number = 0;
  public payments: number = 0;
  public pdfPath: string;
  public postalCode: string;
  public statementDetails: {
    data: IStatementData[];
    pageNumber: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
  };
  public currentTotal: number = 0;
  public oneMonthPastTotal: number = 0;
  public twoMonthsPastTotal: number = 0;
  public threeMonthsPastTotal: number = 0;
  public total: number = 0;
  public statementDate: string;
}

export default MonthlyStatementModel;
